import React, { useCallback, useContext } from 'react';
import { Col } from './styles';
import ScorecardContext from 'contexts/ScorecardContext';
import { Z_INDEX } from '../../../constants';
import { KPI_HEADER_COL_HEIGHT } from './constants';
import Typography from 'kingpin/atoms/Typography';

const ColumnHeadingsLeft = () => {
  const { setHoveredKpiId } = useContext(ScorecardContext);

  const onKpiMouseEnter = useCallback(() => {
    setHoveredKpiId(undefined);
  }, [setHoveredKpiId]);

  return (
    <Col
      maxWidth
      onMouseEnter={onKpiMouseEnter}
      style={{
        position: 'sticky',
        top: 0,
        backgroundColor: 'var(--color-bg-primary)',
        zIndex: Z_INDEX.SCORECARD_COLUMN_HEADING,
        padding: '8px 0',
        height: `${KPI_HEADER_COL_HEIGHT + 2}px`,
        borderBottom: `1px solid var(--color-grid-border)`,
        borderTop: `1px solid var(--color-grid-border)`,
      }}
    >
      <div style={{ visibility: 'hidden' }}>
        <Typography.Body type="Body 12">-</Typography.Body>
      </div>
    </Col>
  );
};

export default ColumnHeadingsLeft;
